import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '../../Buttons/IconButtonTooltip';
import ResetIcon from '@material-ui/icons/Replay';
import DeleteIcon from '@material-ui/icons/Clear';
import GetStatusIcon from '@material-ui/icons/GetApp';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PlayIcon from '@material-ui/icons/PlayArrow';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useLocation } from 'react-router-dom';

export const columns = [
    { label: 'naam', key: 'name', status: false },
    { label: 'email', key: 'email', status: false },
    { label: 'status', key: 'status', status: true },
    { label: 'step', key: 'step', status: true },
    { label: 'attempts', key: 'attempts', status: true },
    { label: 'actions', key: 'actions', status: false },
    // { label: 'token', key: 'userToken' },
];

const UserItem = ({ user, addUserStatus, deleteUser, resetUser, disabled }) => {
    const location = useLocation();

    const baseUrl = window.location.href.replace(
        new RegExp(location.pathname + '$'),
        ''
    );
    const gameUrl = `${baseUrl}/student?key=${user.userToken}`;

    const handlePlay = () => {
        window.open(gameUrl);
    };

    return (
        <TableRow>
            {columns.map((col) => {
                let cellContent = null;
                if (col.key === 'actions') {
                    cellContent = (
                        <>
                            <IconButton
                                tooltip="naar speler omgeving"
                                size="small"
                                color="primary"
                                onClick={handlePlay}
                                disabled={disabled}
                            >
                                <PlayIcon />
                            </IconButton>
                            <CopyToClipboard text={gameUrl}>
                                <IconButton
                                    tooltip="kopieer speler URL"
                                    size="small"
                                    color="primary"
                                    disabled={disabled}
                                >
                                    <AssignmentIcon />
                                </IconButton>
                            </CopyToClipboard>
                            <IconButton
                                tooltip="game resetten"
                                size="small"
                                color="secondary"
                                onClick={resetUser}
                                disabled={disabled}
                            >
                                <ResetIcon />
                            </IconButton>
                            <IconButton
                                tooltip="speler verwijderen"
                                size="small"
                                color="secondary"
                                onClick={() => {
                                    deleteUser();
                                }}
                                disabled={disabled}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </>
                    );
                } else if (typeof user[col.key] === 'undefined' && col.status) {
                    cellContent = (
                        <IconButton
                            aria-label="get status"
                            size="small"
                            onClick={() => addUserStatus()}
                            disabled={disabled}
                        >
                            <GetStatusIcon />
                        </IconButton>
                    );
                } else {
                    cellContent = user[col.key];
                }
                return <TableCell key={col.key}>{cellContent}</TableCell>;
            })}
        </TableRow>
    );
};

export default UserItem;
